import type { CsSelectPopoverOption } from 'components/cs-select-popover/cs-select-popover';
import type { PopupMenuButton } from './popup-menu';

/**
 * Turn a PopupMenuButton into the row the select popover draws (recursive for submenus).
 *
 * selectState is linked to the button, not copied. The menu's own tick writes through to the
 * button, and a state the caller changes on the button while the menu is open is what the menu
 * draws. The Progress filters need that: a tap on the other chart's filter clears this chart's
 * filters while the menu stays open (df-acd1f5d5b2a8).
 */
export function toSelectPopoverOption(button: PopupMenuButton): CsSelectPopoverOption {
  return {
    name: button.text,
    value: button.value ?? button.text,
    get selectState() { return button.selectState; },
    set selectState(state: boolean | undefined) { button.selectState = state; },
    handler: button.handler,
    icon: button.icon,
    helpIcon: button.helpIcon,
    description: button.description,
    controlType: button.controlType,
    // map submenu recursively
    submenu: button.submenu ? {
      title: button.submenu.title,
      options: button.submenu.buttons.map(toSelectPopoverOption),
    } : undefined,
  };
}
